<template>
  <div class="body-container update-pwd">
    <div class="form-box">
      <div class="row">
        <div class="label">手机号码</div>
        <input
          v-model.trim="form.mobile"
          placeholder="请输入手机号"
          class="password-input"
        />
      </div>
      <div class="row">
        <div class="label">验证码</div>
        <input
          v-model.trim="form.code"
          placeholder="请输入验证码"
          class="password-input"
        />
        <div
          class="code-btn"
          @click="checkCode"
          v-if="codeIndex == CODE_SIZE"
        >
          获取验证码
        </div>
        <div class="code-btn gray" v-else>{{ codeIndex }}S</div>
      </div>
      <div class="row">
        <div class="label">新密码</div>
        <pwdInput v-model="form.password" placeholder="请输入新密码"></pwdInput>
      </div>
    </div>
    <div class="tip">
      注：新密码8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种
    </div>
    <van-button round class="form-btn" @click="submit">确定</van-button>
    <validCodeModal ref='validCodeModal' @success="openTimer"></validCodeModal>
  </div>
</template>
<script>
import pwdInput from "./components/pwdInput";
import { codeTools, common } from "@/api/mixins";
import validCodeModal from "@/components/validCodeModal";
export default {
  mixins: [codeTools, common],
  components: { pwdInput,validCodeModal },
  data: () => ({
    userFormShow: true,
    form: {},
  }),
  mounted() {
    this.$weixin.hideMenu();
  },
  methods: {
    // 打开短信验证码计时器
    openTimer(data){
      this.form.codeId = data.codeId;
      this.timerStart();
    },
    checkCode() {
      if (this.codeIndex != this.CODE_SIZE) {
        return;
      }
      if (!this.form.mobile  || !this.$regulars.isPhone(this.form.mobile)) {
        this.$notice.msg("请输入正确的手机号");
        return;
      }
      this.$refs.validCodeModal.open({
        requestUrl: sessionStorage.orgId?"/api/user/sendCodeMerVo":"/api/user/sendCode",
        params: {
          mobile: this.form.mobile,
          orgId: sessionStorage.orgId
        }
      });
    },
    submit() {
      if (!this.$regulars.isPhone(this.form.mobile)) {
        this.$notice.msg("请输入正确的手机号码");
        return;
      } else if (!this.form.code) {
        this.$notice.msg("请输入验证码");
        return;
      }else if (!this.form.password) {
        this.$notice.msg("请输入新密码");
        return;
      } else if (
        !this.verification(this.form.password)
      ) {
        return;
      }
      const params = this.form;
      if(sessionStorage.orgId) {
        this.login(params);
      } else {
        this.$http({
          type: "GET",
          url: "/api/user/getMerVo",
          data: {
            mobile: this.form.mobile,
            codeId: this.form.codeId,
            smsCode: this.form.code,
          }
        })
          .then(res => {
            const merVos = res.data.merVos;
            if(!merVos || !merVos.length) {
              this.loading = false;
              this.$notice.msg("商户信息不存在");
              return;
            }
            if(merVos.length == 1) {
              params.merVo = merVos[0].merCode;
              this.login(params)
            } else {
              this.loading = false;
              window.setTimeout(()=>{
                sessionStorage.loginMerchantList = JSON.stringify(merVos);
                sessionStorage.loginInfo = JSON.stringify(params);
                this.$router.push('/apps/selectMerchant?type=resetPwd');
              }, 300)
            }
          }).catch(e=>{
            console.log(e);
            this.loading = false;
          })
      }
      
    },
    login(params){
      this.loading = true;
      this.$http({
        type: "POST",
        url: "/api/user/resetPassword",
        data: this.form,
      })
        .then((resData) => {
          this.loading = false;
          this.$notice.msg("重置密码成功");
          setTimeout(() => {
            this.goPage("/apps/login", this.$route.query);
          }, 100);
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
        });
    }
  },
};
</script>
<style lang="scss" scoped>
@import "./updatePwd.scss";
</style>
